/* eslint-disable max-len */
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useEffect, useState /* createRef */ } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { Alert, Button, Container, Content, FlexboxGrid, Table } from 'rsuite';
import { LoadingSpiner } from '../../../../../components/LoadingSpinner';
import { getClusters } from '../../services';
import { listBlocos } from '../BlocoDeOferta/services';
import Steps from '../Components/Steps';
import { getCampaign } from '../services';
import { colunasTableLojasParticipantes } from './Components/Columns';
import { deleteLojaParticipante, getLojas, getLojasParticipantes, getTiposLojas, saveLojasParticipantes } from './services';
// import BotaoFiltro from './Components/Filtro';
import { MdDelete } from 'react-icons/md';
import { ConfirmDeleteModal } from '../../Components/Modals/ConfirmDelete/ConfirmDeleteModal';
import Header from '../Components/Header';
import { getOffers } from '../Ofertas/services';
import ModalLojasParticipantes from './Components/ModalLojasParticipantes';

const { Column, HeaderCell, Cell, Pagination } = Table;

const LojasParticipantes = ({ history }) => {
  const { id } = useParams();
  const [lojasParticipantesSelecionadas, setLojasParticipantesSelecionadas] = useState([]);
  const [lojasParticipantes, setLojasParticipantes] = useState({
    content: [],
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(20);
  const [showModalLojasParicipantes, setModalLojasParticipantes] = useState(false);
  const [campanha, setCampanha] = useState({});
  const [blocosOfertas, setBlocosOfertas] = useState({});
  const [deleteMessage, setDeleteMessage] = useState('');
  const [lojaToDelete, setLojaToDelete] = useState(null);
  const [showModalConfirmacaoExclusao, setShowModalConfirmacaoExclusao] = useState(false);
  const [tiposLoja, setTiposLoja] = useState({ content: [] });
  const [lojas, setLojas] = useState({ content: [] });
  const [clusters, setClusters] = useState([]);
  const [ofertas, setOfertas] = useState({ content: [] });
  const isCampaignReadOnly = campanha.status === 'CURRENT' || campanha.status === 'CLOSED';

  const back = () => {
    history.push(`/ipa/campanhas/cadastro/dados-campanha/${id}`);
  };

  const goToBlocos = () => {
    history.push(`/ipa/campanhas/cadastro/blocos-de-oferta/${id}`);
  };

  const goToOfertas = () => {
    history.push(`/ipa/campanhas/cadastro/ofertas/${id}`);
  };

  const listLojas = async (page, size, tipoLojaSelecionado, clusterSelecionado, buscaLoja) => {
    const resp = await getLojas({
      page,
      size,
      storeType: tipoLojaSelecionado?.value,
      storeCluster: clusterSelecionado,
      storeName: buscaLoja,
      campaignId: id,
    });
    setLojas({
      ...resp,
      content: resp.content.map(item => ({
        ...item,
        store: item.store_id + ' - ' + item.store,
      })),
    });
  };

  const listLojasSelecionadas = () => {
    if (lojas.content.length && lojasParticipantes.content.length) {
      let lojasSelecionadas = [...lojasParticipantesSelecionadas, ...lojas.content.filter(item => item.checked)];
      lojasSelecionadas = [...new Map(lojasSelecionadas.map(item => [item.store_id, item])).values()];
      setLojasParticipantesSelecionadas(lojasSelecionadas);
    }
  };

  const listLojasParticipantes = async () => {
    const response = await getLojasParticipantes({
      id,
      page,
      size,
    });
    if (response) {
      setLojasParticipantes(response);
    }
  };

  const listCampaign = async () => {
    const response = await getCampaign(id);
    if (response) {
      setCampanha(response.data);
    }
  };

  const listBlocosOfertas = async () => {
    const response = await listBlocos(id);
    if (response) setBlocosOfertas(response);
  };

  const confirmLoja = async () => {
    if (isCampaignReadOnly) return;

    const data = {
      client_id: JSON.parse(localStorage.getItem('cliente'))?.codigo,
      stores: lojasParticipantesSelecionadas.map(item => ({
        store_name: item.store,
        store_id_external: item.store_id,
        store_type: item.store_type,
        store_cluster: item.store_cluster,
      })),
    };
    const resp = await saveLojasParticipantes({
      data,
      id,
    });
    if (resp) {
      listLojasParticipantes();
      setLojasParticipantesSelecionadas([]);
      setModalLojasParticipantes(false);
      listLojasSelecionadas();
    }
  };

  const closeLoja = () => {
    setLojasParticipantesSelecionadas([]);
    setModalLojasParticipantes(false);
    listLojasSelecionadas();
    listLojas();
  };

  const removeLoja = id => {
    if (isCampaignReadOnly) return;

    setDeleteMessage('Você está tentando remover uma loja participante. Você confirma essa ação?');
    setShowModalConfirmacaoExclusao(true);
    setLojaToDelete(id);
  };

  const closeExclusao = () => {
    setDeleteMessage('');
    setShowModalConfirmacaoExclusao(false);
    setLojaToDelete(null);
  };

  const confirmExclusao = () => {
    if (isCampaignReadOnly) return;

    deleteLojaParticipante(id, lojaToDelete).then(() => {
      Alert.success('Loja participante excluída com sucesso.');
      listLojasParticipantes();
      closeExclusao();
    });
  };

  const listTiposLojas = async () => {
    const response = await getTiposLojas(id);
    setTiposLoja(
      response.map(item => ({
        value: item,
        label: item,
      })),
    );
  };

  const getClustersCliente = async () => {
    const resp = await getClusters();
    setClusters(
      resp.map(item => ({
        value: item.store_cluster,
        label: item.store_cluster,
      })),
    );
  };

  const listOfertas = async () => {
    const response = await getOffers({
      id,
      page: 0,
      size: 20,
    });
    if (response) {
      setOfertas(response);
    }
  };

  const campaignTag = `#${campanha.campaign_type_order} ${campanha.campaign_type}`;

  useEffect(() => {
    listCampaign();
    listBlocosOfertas();
    listTiposLojas();
    getClustersCliente();
    listOfertas();
  }, []);

  useEffect(() => {
    listLojasParticipantes();
  }, [page, size]);

  useEffect(() => {
    listLojasSelecionadas();
  }, [lojas, lojasParticipantes]);

  return (
    <Container className="main-container cadastro-lojas-participantes-page">
      <Steps rota={history.location.pathname} campanhaId={id} status={campanha?.status} lojas={lojasParticipantes?.content?.length} />
      <LoadingSpiner size="md" />
      <Header
        history={history}
        id={id}
        name={campanha?.name}
        status={campanha?.status}
        backToCampaign={back}
        startingDate={campanha?.starting_date}
        expirationDate={campanha?.expiration_date}
        blocosOfertas={blocosOfertas?.totalElements}
        lojasParticipantes={lojasParticipantes?.totalElements}
        ofertas={ofertas?.totalElements}
        campaignTag={campaignTag}
      />
      <Content className="lojas-participantes">
        <FlexboxGrid justify="space-between" align="middle">
          <FlexboxGrid.Item>
            <h3>Lojas participantes</h3>
            <p className="description">Escolha as lojas participantes da campanha</p>
          </FlexboxGrid.Item>

          <FlexboxGrid justify="space-between" align="middle" className="btn-add-container">
            <FlexboxGrid.Item>
              <Button
                className="btn-add-stores"
                appearance="ghost"
                title="Adicionar lojas"
                block
                onClick={() => setModalLojasParticipantes(true)}
                disabled={isCampaignReadOnly}
              >
                Adicionar lojas
              </Button>
            </FlexboxGrid.Item>
          </FlexboxGrid>

          <FlexboxGrid.Item className="lojas-participantes-container" colspan={24}>
            {!lojasParticipantes?.content?.length ? (
              <FlexboxGrid className="no-data" justify="center" align="middle">
                <FlexboxGrid.Item>
                  <p>Não há lojas participantes adicionadas</p>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : (
              <Container>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item colspan={24}></FlexboxGrid.Item>
                  <FlexboxGrid.Item colspan={24}>
                    <div className="campanhas-table-container">
                      <Table className="table" data={lojasParticipantes.content} autoHeight>
                        {colunasTableLojasParticipantes.map(coluna =>
                          !coluna.dataKey ? (
                            <Column width={120} fixed="right" key={Math.random()}>
                              <HeaderCell />

                              <Cell className="table__edit-button">
                                {rowData => (
                                  <span className="action-buttons">
                                    <Button
                                      title="Deletar"
                                      size="md"
                                      onClick={() => removeLoja(rowData.id)}
                                      disabled={isCampaignReadOnly}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </span>
                                )}
                              </Cell>
                            </Column>
                          ) : (
                            <Column
                              flexGrow={coluna.flexGrow}
                              sortable={coluna.sortable}
                              align={coluna.align}
                              fixed={coluna.fixed}
                              width={coluna.width}
                              key={Math.random()}
                            >
                              <HeaderCell>{coluna.headerCell}</HeaderCell>
                              <Cell dataKey={coluna.dataKey} />
                            </Column>
                          ),
                        )}
                      </Table>
                      <Pagination
                        lengthMenu={[
                          {
                            value: 20,
                            label: 20,
                          },
                          {
                            value: 40,
                            label: 40,
                          },
                        ]}
                        activePage={lojasParticipantes.number + 1}
                        displayLength={lojasParticipantes.size}
                        total={lojasParticipantes.totalElements}
                        onChangePage={value => setPage(value - 1)}
                        onChangeLength={value => setSize(value)}
                      />
                    </div>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </Container>
            )}
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
      <Content className="navegacao-lojas-participantes">
        <FlexboxGrid justify="space-between">
          <FlexboxGrid.Item>
            <Button appearance="link" onClick={goToBlocos}>
              <ArrowBackIcon /> Voltar para blocos de ofertas
            </Button>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item>
            <Button appearance="primary" disabled={!lojasParticipantes.content.length} onClick={goToOfertas}>
              <ArrowForwardIcon /> {isCampaignReadOnly ? 'ITENS OFERTADOS' : 'OFERTAR ITENS'}
            </Button>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
      <ModalLojasParticipantes
        show={showModalLojasParicipantes}
        confirmLoja={confirmLoja}
        closeLoja={closeLoja}
        id={id}
        lojasParticipantesSelecionadas={lojasParticipantesSelecionadas}
        setLojasParticipantesSelecionadas={setLojasParticipantesSelecionadas}
        tiposLoja={tiposLoja}
        clusters={clusters}
        listLojas={listLojas}
        lojas={lojas}
      />
      <ConfirmDeleteModal
        open={showModalConfirmacaoExclusao}
        onConfirm={confirmExclusao}
        onCancel={closeExclusao}
        title="Remover Loja Participante"
        message={deleteMessage}
      />
    </Container>
  );
};

export default withRouter(LojasParticipantes);
